import * as yup from 'yup';

export const SellersValidationSchema = yup.object().shape({
  book: yup.mixed().required( 'El libro es requerido' ),
  tags: yup.array().min( 1, 'Se requiere al menos 1 tag' ).max( 10, 'No puedes indicar más de 10 tags' ).required( 'Los tags son requerido' ),
  quantity: yup.number().min( 1, 'La cantidad mínima de códigos debe ser de 1' ).max( 2500, 'La cantidad máxima de códigos es de 2500' ).required( 'El número de códigos es requerido' ),
});
